import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheFutureOfAutomation from "./sections/TheFutureOfAutomation";
import DeepDiveAnalysis from "./sections/DeepDiveAnalysis";
import WhyTrustOurLab from "./sections/WhyTrustOurLab";
import WhatTechLeadersSay from "./sections/WhatTechLeadersSay";
import GetTheAiEdge from "./sections/GetTheAiEdge";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheFutureOfAutomation />
      <DeepDiveAnalysis />
      <WhyTrustOurLab />
      <WhatTechLeadersSay />
      <GetTheAiEdge />
      <Footer />
    </div>;
}